<template>
  <div class="share-contrainer">
    <div class="share-box">
      <img src="../../assets/shareCheck.png" alt="" />
      <div class="title">请输入访问密码</div>
      <el-input v-model="password" placeholder="请输入密码" class="psd-input"></el-input>
      <el-button type="primary" class="submit-btn" :loading="loading" @click="submitCkeck"
        >确认</el-button
      >
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { ref } from 'vue'
  import { ElMessage } from 'element-plus'
  import { useRoute, useRouter } from 'vue-router'
  import { usePreviewHook } from '@haohan/clw-hooks'
  import { useGlobalStore } from '@haohan/clw-store'
  const route = useRoute()
  const router = useRouter()
  const globalStore = useGlobalStore()
  const { toPreviewPage } = usePreviewHook(route.query.projectId as string, router)

  const password = ref('')
  const loading = ref(false)

  // 提交验证
  const submitCkeck = async () => {
    if (!password.value.length) {
      return ElMessage.warning('请输入密码')
    }
    const shareId: any = route.query.shareId
    loading.value = true
    globalStore
      .checkProjectShare(shareId, { password: password.value })
      .then((res) => {
        if (res) {
          toPreviewPage(route.query.shareId as string)
        }
      })
      .finally(() => {
        loading.value = false
      })
  }

  // 获得环境信息
  globalStore.getEnvInfo()
</script>
<style lang="scss" scoped>
  .share-contrainer {
    height: 100%;
    background-color: #e7ecf0;
    position: relative;
    .share-box {
      width: 530px;
      padding: 30px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      img {
        width: 190px;
      }
      .title {
        font-weight: bold;
        font-size: 27px;
        color: #000000;
      }
      .psd-input {
        margin-top: 55px;
        height: 62px;
        border: 1px solid #0076de;
        border-radius: 10px;
        overflow: hidden;
        :deep(.el-input__wrapper) {
          background: rgba(0, 118, 222, 0.12);
          .el-input__inner::-webkit-input-placeholder {
            font-size: 15px;
            color: #001b33;
          }
        }
      }
      .submit-btn {
        width: 100%;
        height: 62px;
        background: linear-gradient(140deg, #0076de 0%, #64e3f4 100%);
        border-radius: 10px;
        border: 0px solid #fff;
        margin-top: 35px;
        font-size: 15px;
      }
    }
  }
</style>
